
import * as React from 'react';
import { actionCreators } from './actions';
import { containerFactory } from 'app/infrastructure/redux/index';
import { STATE } from 'app/constants';
import { safeNumericString } from 'app/infrastructure/data/sanitize';
import { SpinLoader } from 'app/components/spin-loader';
import { DraftProps } from 'app/area/case/draft/types';

/**
 * Runs the action creator to change the case type then redirects to the draft
 *
 */
export interface ChangeCaseTypeComponentProps {
  caseTypeId: string;
  draftId?: string;
  changeCaseType: (caseTypeId: string, draftId: string) => void;
}
export class ChangeCaseTypeComponent extends React.Component<ChangeCaseTypeComponentProps> {

  public static statePath: string = STATE.case;

  public componentDidMount() {
    const {caseTypeId, draftId, changeCaseType} = this.props;
    changeCaseType(caseTypeId, draftId);
  }

  public render() { return <SpinLoader /> }
}

const selectors = {
  caseTypeId: (_, props: DraftProps) => safeNumericString(props.params.caseTypeId.split('?')[0]),
  draftId: (_, props: DraftProps) =>
    props.router.location.query && safeNumericString(props.router.location.query.draftId)
};

const container = containerFactory(ChangeCaseTypeComponent, actionCreators, selectors);

export { container as ChangeCaseType };
